module.exports = __webpack_public_path__ + "img/ic_map_city_center.f94bd39d.svg";